import api from "PFCore/api";
import { ProfileMinimized } from "PFTypes";

enum FollowState {
  Following = "following",
  Ignore = "ignore"
}

type FollowParticipantResponse = {
  entries: ProfileMinimized[];
  meta: { total: number };
};

export const followParticipant = (id: number, follow: boolean): Promise<FollowParticipantResponse> =>
  api({
    url: `chat/participants/${id}`,
    method: "PUT",
    data: {
      notificationState: follow ? FollowState.Following : FollowState.Ignore
    }
  });
